var __rspack_ns_object = JSON.parse('{"Add Label":"Ajouter une étiquette","Delete measurement":"Supprimer la mesure"}')